// import { MessageSquare, FolderPlus, Grid2x2 } from 'lucide-react';
import {
  // MessageSquare,
  Search,
  GalleryVerticalEnd,
  Grid2x2,
  Share2,
  ChevronDown,
  Folder,
  // UsersRound,
  // Group,
  // UsersRound,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18nInstance from '@/i18n/config';
import { useUIStore } from '@/stores';

interface NavigationMenuProps {
  isCollapsed: boolean;
  selectedNavItem: string;
  currentProjectId?: string | null;
  projectSelectedFrom?: 'starred' | 'projects' | null;
  onSelectedNavItem: (item: string) => void;
  onBackToChat: () => void;
  onBackToGeneralChats: () => void;
  onProjectSelect: (projectId: string | null) => void;
  onConversationSelect: (id: string, projectId?: string) => void;
  onShowAgentList: () => void;
  onShowSharedList: () => void;
  onNewProject: () => void;
  onShowProjectsList: () => void;
  onToggleProjectsExpand: () => void;
  onSetProjectSelectedFrom?: (source: 'starred' | 'projects') => void;
  isProjectsExpanded: boolean;
  projects?: any[];
  unvisitedProjectsCount?: number; // 未访问的项目数量
  unvisitedSharedCount?: number; // 未访问的分享数量
  // Group chats props
  isGroupChatsExpanded?: boolean;
  onToggleGroupChatsExpand?: () => void;
  onShowGroupChats?: () => void;
  groupChatsCount?: number;
  groupConversations?: any[];
  groupChatsLoading?: boolean;
  onGroupChatSelect?: (conversationId: string) => void;
}
export default function NavigationMenu({
  isCollapsed,
  selectedNavItem,
  currentProjectId,
  projectSelectedFrom,
  onSelectedNavItem,
  onBackToChat,
  onBackToGeneralChats,
  onProjectSelect,
  onConversationSelect,
  onShowAgentList,
  onShowSharedList,
  // onNewProject,
  onShowProjectsList,
  onToggleProjectsExpand,
  onSetProjectSelectedFrom,
  isProjectsExpanded,
  projects = [],
  unvisitedProjectsCount = 0,
  unvisitedSharedCount = 0,
  // Group chats
  // isGroupChatsExpanded = false,
  // onToggleGroupChatsExpand,
  // onShowGroupChats,
  // groupChatsCount = 0,
  // groupConversations = [],
  // groupChatsLoading = false,
  // onGroupChatSelect,
}: NavigationMenuProps) {
  const { t } = useTranslation();
  const [showAllProjects, setShowAllProjects] = useState(false);
  const [, setForceUpdate] = useState(0);
  const { fetchAgents } = useUIStore();

  // 监听语言变化
  useEffect(() => {
    const handleLanguageChange = () => {
      setForceUpdate(n => n + 1);
    };
    i18nInstance.on('languageChanged', handleLanguageChange);
    return () => {
      i18nInstance.off('languageChanged', handleLanguageChange);
    };
  }, []);

  // Reset to show only 5 projects when Projects section is collapsed
  useEffect(() => {
    if (!isProjectsExpanded) {
      setShowAllProjects(false);
    }
  }, [isProjectsExpanded]);

  // Filter out archived projects
  const activeProjects = projects.filter(p => !p.archived);
  const displayedProjects = showAllProjects
    ? activeProjects
    : activeProjects.slice(0, 5);
  const hasMoreProjects = activeProjects.length > 5;

  if (isCollapsed) {
    return (
      <nav className="space-y-1 mb-1">
        <div
          className={cn(
            'flex justify-center p-2 text-gray-700 hover:bg-[#e8e6dc] rounded-lg transition-colors cursor-pointer',
            selectedNavItem === 'chats' && 'bg-[#e8e6dc]'
          )}
          onClick={() => {
            onSelectedNavItem('chats');
            onBackToChat();
            if (currentProjectId) {
              onBackToGeneralChats();
            }
          }}
          title={t('sidebar.chats')}
        >
          {/* <MessageSquare size={16} /> */}
          <Search size={16} />
        </div>
        <div
          className={cn(
            'flex justify-center p-2 text-gray-700 hover:bg-[#e8e6dc] rounded-lg transition-colors cursor-pointer relative',
            selectedNavItem === 'projects' && 'bg-[#e8e6dc]'
          )}
          onClick={() => {
            onSelectedNavItem('projects');
            onShowProjectsList();
          }}
          title={t('sidebar.projects')}
        >
          <GalleryVerticalEnd size={16} />
          {unvisitedProjectsCount > 0 && (
            <span className="absolute -top-1 right-1 min-w-[16px] h-4 px-0 bg-red-500 text-white text-[10px] font-medium rounded-full flex items-center justify-center">
              {unvisitedProjectsCount > 99 ? '99+' : unvisitedProjectsCount}
            </span>
          )}
        </div>
        {/* <div
          className={cn(
            'flex justify-center p-2 text-gray-700 hover:bg-[#e8e6dc] rounded-lg transition-colors cursor-pointer relative',
            selectedNavItem === 'groupChats' && 'bg-[#e8e6dc]'
          )}
          onClick={() => {
            onSelectedNavItem('groupChats');
            if (currentProjectId) {
              onBackToGeneralChats();
              onProjectSelect(null);
            }
            onShowGroupChats?.();
          }}
          title="Group chats"
        >
          <UsersRound size={16} />
          {groupChatsCount > 0 && (
            <span className="absolute -top-1 right-1 min-w-[16px] h-4 px-0 bg-red-500 text-white text-[10px] font-medium rounded-full flex items-center justify-center">
              {groupChatsCount > 99 ? '99+' : groupChatsCount}
            </span>
          )}
        </div> */}
        <div
          className={cn(
            'flex justify-center p-2 text-gray-700 hover:bg-[#e8e6dc] rounded-lg transition-colors cursor-pointer relative',
            selectedNavItem === 'shared' && 'bg-[#e8e6dc]'
          )}
          onClick={() => {
            onSelectedNavItem('shared');
            if (currentProjectId) {
              onBackToGeneralChats();
              onProjectSelect(null);
            }
            onShowSharedList();
          }}
          title={t('sidebar.shared')}
        >
          <Share2 size={16} />
          {unvisitedSharedCount > 0 && (
            <span className="absolute -top-1 right-1 min-w-[16px] h-4 px-0 bg-red-500 text-white text-[10px] font-medium rounded-full flex items-center justify-center">
              {unvisitedSharedCount > 99 ? '99+' : unvisitedSharedCount}
            </span>
          )}
        </div>
        {/* <div
          className={cn(
            'flex justify-center p-2 text-gray-700 hover:bg-[#e8e6dc] rounded-lg transition-colors cursor-pointer',
            selectedNavItem === 'Database' && 'bg-[#e8e6dc]'
          )}
          onClick={() => {
            onSelectedNavItem('Database');
            if (currentProjectId) {
              onProjectSelect(null);
            }
            onConversationSelect('', undefined);
            onShowPDFList();
          }}
          title={t('sidebar.database')}
        >
          <Database size={16} />
        </div> */}
        <div
          className={cn(
            'flex justify-center p-2 text-gray-700 hover:bg-[#e8e6dc] rounded-lg transition-colors cursor-pointer',
            selectedNavItem === 'agents' && 'bg-[#e8e6dc]'
          )}
          onClick={() => {
            onSelectedNavItem('agents');
            if (currentProjectId) {
              onProjectSelect(null);
            }
            onConversationSelect('', undefined);
            onShowAgentList();
            // Refresh agents data when entering Agents page
            fetchAgents();
          }}
          title={t('sidebar.agents')}
        >
          <Grid2x2 size={16} />
        </div>
      </nav>
    );
  }
  return (
    <nav className="space-y-1 mb-1">
      <div
        className={cn(
          'flex items-center gap-3 px-2 py-2 text-gray-700 hover:bg-[#e8e6dc] rounded-lg transition-colors cursor-pointer',
          selectedNavItem === 'chats' && 'bg-[#e8e6dc]'
        )}
        onClick={() => {
          onSelectedNavItem('chats');
          onBackToChat();
          if (currentProjectId) {
            onBackToGeneralChats();
          }
        }}
      >
        {/* <MessageSquare size={16} /> */}
        <Search size={16} />
        <span className="text-sm font-medium">{t('sidebar.chats')}</span>
      </div>
      <div
        className={cn(
          'flex items-center justify-between gap-3 px-2 py-2 text-gray-700 rounded-lg transition-colors group',
          selectedNavItem === 'projects' ? 'bg-[#e8e6dc]' : 'hover:bg-[#e8e6dc]'
        )}
      >
        <div
          className="flex-1 flex items-center gap-3 cursor-pointer"
          onClick={() => {
            onSelectedNavItem('projects');
            onShowProjectsList();
          }}
        >
          <GalleryVerticalEnd size={16} />
          <span className="text-sm font-medium">{t('sidebar.projects')}</span>
          {unvisitedProjectsCount > 0 && (
            <span className="min-w-[18px] h-[18px] bg-red-500 text-white text-[10px] font-medium rounded-full flex items-center justify-center">
              {unvisitedProjectsCount > 99 ? '99+' : unvisitedProjectsCount}
            </span>
          )}
        </div>
        <button
          onClick={e => {
            e.stopPropagation();
            onToggleProjectsExpand();
          }}
          className="p-1 hover:bg-gray-200 rounded opacity-0 group-hover:opacity-100 transition-opacity"
          title={
            isProjectsExpanded
              ? t('sidebar.collapseProjects')
              : t('sidebar.expandProjects')
          }
        >
          <ChevronDown
            size={16}
            className={cn(
              'transition-transform',
              isProjectsExpanded && 'rotate-180'
            )}
          />
        </button>
      </div>

      {/* Expanded Projects List */}
      {isProjectsExpanded && (
        <div className="ml-3 border-gray-200 space-y-1 my-1 overflow-y-auto max-h-80">
          {projects.length === 0 ? (
            <div className="pl-2 py-1.5 text-xs text-gray-400">
              {t('sidebar.noProjects')}
            </div>
          ) : (
            <>
              {displayedProjects.map(project => (
                <div
                  key={project.id}
                  onClick={() => {
                    onSetProjectSelectedFrom?.('projects');
                    onProjectSelect(project.id);
                    onSelectedNavItem('');
                  }}
                  className={cn(
                    'px-3 py-1.5 text-sm text-gray-600 rounded-md hover:bg-[#e8e6dc] cursor-pointer truncate transition-colors',
                    currentProjectId === project.id &&
                      projectSelectedFrom === 'projects' &&
                      'bg-[#e8e6dc] text-gray-900 font-medium'
                  )}
                  title={project.name}
                >
                  <Folder size={16} className="inline-block mr-2 mb-0.5" />
                  {project.name}
                </div>
              ))}
              {!showAllProjects && hasMoreProjects && (
                <div
                  onClick={() => setShowAllProjects(true)}
                  className="px-3 py-1.5 text-xs font-medium text-gray-500 hover:text-gray-700 hover:bg-[#e8e6dc] rounded-md cursor-pointer transition-colors"
                >
                  {t('sidebar.viewAllProjects')}
                </div>
              )}
            </>
          )}
        </div>
      )}

      <div
        className={cn(
          'flex items-center gap-3 px-2 py-2 text-gray-700 hover:bg-[#e8e6dc] rounded-lg transition-colors cursor-pointer',
          selectedNavItem === 'shared' && 'bg-[#e8e6dc]'
        )}
        onClick={() => {
          onSelectedNavItem('shared');
          if (currentProjectId) {
            onBackToGeneralChats();
            onProjectSelect(null);
          }
          onShowSharedList();
        }}
      >
        <Share2 size={16} />
        <span className="text-sm font-medium">{t('sidebar.shared')}</span>
        {unvisitedSharedCount > 0 && (
          <span className="min-w-[18px] h-[18px] px-1.5 bg-red-500 text-white text-[10px] font-medium rounded-full flex items-center justify-center">
            {unvisitedSharedCount > 99 ? '99+' : unvisitedSharedCount}
          </span>
        )}
      </div>

      <div
        className={cn(
          'flex items-center gap-3 px-2 py-2 text-gray-700 hover:bg-[#e8e6dc] rounded-lg transition-colors cursor-pointer',
          selectedNavItem === 'agents' && 'bg-[#e8e6dc]'
        )}
        onClick={() => {
          onSelectedNavItem('agents');
          if (currentProjectId) {
            onProjectSelect(null);
          }
          onConversationSelect('', undefined);
          onShowAgentList();
        }}
      >
        <Grid2x2 size={16} />
        <span className="text-sm font-medium">{t('sidebar.agents')}</span>
      </div>

      {/* Group Chats Navigation */}
      {/* <div
        className={cn(
          'flex items-center justify-between gap-3 px-2 py-2 text-gray-700 rounded-lg transition-colors group',
          selectedNavItem === 'groupChats'
            ? 'bg-[#e8e6dc]'
            : 'hover:bg-[#e8e6dc]'
        )}
      >
        <div
          className="flex-1 flex items-center gap-3 cursor-pointer"
          onClick={() => {
            onSelectedNavItem('groupChats');
            if (currentProjectId) {
              onBackToGeneralChats();
              onProjectSelect(null);
            }
            onShowGroupChats?.();
          }}
        >
          <Group size={16} />
          <span className="text-sm font-medium">{t('sidebar.groupChats')}</span>
          {groupChatsCount > 0 && (
            <span className="min-w-[18px] h-[18px] px-1.5 bg-red-500 text-white text-[10px] font-medium rounded-full flex items-center justify-center">
              {groupChatsCount > 99 ? '99+' : groupChatsCount}
            </span>
          )}
        </div>
        <button
          onClick={e => {
            e.stopPropagation();
            onToggleGroupChatsExpand?.();
          }}
          className="p-1 hover:bg-gray-200 rounded opacity-0 group-hover:opacity-100 transition-opacity"
          title={
            isGroupChatsExpanded ? 'Collapse group chats' : 'Expand group chats'
          }
        >
          <ChevronDown
            size={16}
            className={cn(
              'transition-transform',
              isGroupChatsExpanded && 'rotate-180'
            )}
          />
        </button>
      </div> */}

      {/* Expanded Group Chats List */}
      {/* {isGroupChatsExpanded && (
        <div className="ml-3 border-gray-200 space-y-1 my-1 overflow-y-auto max-h-80">
          {groupChatsLoading ? (
            <div className="pl-2 py-1.5 text-xs text-gray-400">{t('sidebar.loading')}</div>
          ) : groupConversations.length === 0 ? (
            <div className="pl-2 py-1.5 text-xs text-gray-400">
              No group chats yet
            </div>
          ) : (
            <>
              {groupConversations.slice(0, 5).map(conversation => (
                <div
                  key={conversation.id}
                  onClick={() => onGroupChatSelect?.(conversation.id)}
                  className={cn(
                    'px-3 py-1.5 text-sm text-gray-600 rounded-md hover:bg-[#e8e6dc] cursor-pointer truncate transition-colors',
                    selectedNavItem === 'groupChats' && 'font-medium'
                  )}
                  title={conversation.title || 'Group Chat'}
                >
                  <UsersRound size={14} className="inline-block mr-2 mb-0.5" />
                  {conversation.title || 'Group Chat'}
                </div>
              ))}
              {groupConversations.length > 5 && (
                <div
                  onClick={() => onShowGroupChats?.()}
                  className="px-3 py-1.5 text-xs font-medium text-gray-500 hover:text-gray-700 hover:bg-[#e8e6dc] rounded-md cursor-pointer transition-colors"
                >
                  All group chats
                </div>
              )}
            </>
          )}
        </div>
      )} */}
      {/* <div
        className={cn(
          'flex items-center gap-3 px-2 py-2 text-gray-700 hover:bg-[#e8e6dc] rounded-lg transition-colors cursor-pointer',
          selectedNavItem === 'artifacts' && 'bg-[#e8e6dc]'
        )}
        onClick={() => onNewProject()}
      >
        <FolderPlus size={16} />
        <span className="text-sm font-medium">{t('sidebar.newProject')}</span>
      </div> */}
    </nav>
  );
}
